import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AccessPage } from './pages/AccessPage';
import { Dashboard } from './pages/Dashboard';
import { Profile } from './pages/Profile';
import { ProtectedRoute } from './components/ProtectedRoute';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<AccessPage data-id="element-3" />} data-id="element-2" />
        <Route path="/betiq-dashboard" element={<ProtectedRoute data-id="element-5">
              <Dashboard data-id="element-6" />
            </ProtectedRoute>} data-id="element-4" />
        <Route path="/profile" element={<ProtectedRoute data-id="element-8">
              <Profile data-id="element-9" />
            </ProtectedRoute>} data-id="element-7" />
      </Routes>
    </BrowserRouter>;
}